export default __webpack_public_path__ + "static/media/SAS Chat Tone 1.a55287a8.wav";